const FeatureTextSection = ({
  title,
  subline,
  minisubline,
  description,
  color,
  customClassName = "py-20 text-center",
}) => {
  return (
    <div className={`bg-gray-100 w-full ${customClassName}`}>
      <div className="max-w-5xl mx-auto px-4">
        <h2
          className={`text-5xl font-extrabold text-center`}
        >
          {title}
        </h2>
        {subline && (
          <h3 className="text-5xl font-extrabold mt-3 text-center">
            {subline}
          </h3>
        )}
        {minisubline && (
          <h3
            className={`text-2xl mt-3 font-sans text-center`}
          >
            {minisubline}
          </h3>
        )}
        {description && (
          <p className="text-xl text-gray-600 mt-8 leading-9 text-center">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default FeatureTextSection;
